module.exports = __webpack_public_path__ + "static/media/app_logo@2x.c4475868.png";